import React from 'react'
import LatinoTemplateDefault from 'src/components/template/la'
import { videos } from 'src/constants/videos'
import { sportIds, leagueIds } from 'src/constants/personalizationIds'
import styled from 'styled-components'
export default (props) => {
  return (
    <StyledContainer>
      <LatinoTemplateDefault
        location={props.location}
        lang="en"
        market="latino"
        video={videos.generic_soccer.videoUrl}
        title="Watch El Clásico online"
        subtitle="Real Madrid vs Barcelona live"
        networkSet="soccerLatino"
        noteLink="/la/clasico-es/"
        sportId={sportIds.Soccer}
        leagueId={leagueIds['La Liga']}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  .content-container .hero-content {
    max-width: 712px;
  }
`
